import { FormBase } from "../../util/form-base-form";

class OptionSelectorForm extends FormBase {
    public getWraps(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, ".js-option-selector", HTMLElement);
    }

    public getLabels(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, ".option-label", HTMLElement);
    }

    public getCheckedRadio(root: ParentNode): HTMLInputElement | null {
        return this.getInput(root, 'input[type="radio"]:checked');
    }
}

const optionSelectorForm = new OptionSelectorForm();

export { OptionSelectorForm, optionSelectorForm };
